import { Box, Container } from '@mui/material'
import React from 'react'
import { Outlet } from 'react-router-dom'

const Layouts = () => {
  return (
    <Container
      maxWidth="xs"
      sx={{
        display: 'flex',
        minHeight: '100vh',
      }}
    >
      <Box flex={'1 1'}>
        <Outlet />
      </Box>
    </Container>
  )
}

export default Layouts
